import styled from "styled-components";

import colors from "../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 100%;

    @media(max-width: 500px){
        /* width: 100%; */
    }
`

export const FilterTitle = styled.span`
  display: flex;
  align-items: center;
  font: normal normal normal 16px Circular Std Book;
  color: ${colors.tertiary};

  @media(max-width: 500px){
    font-size: 12px;
  }
`;

export const FilterInputCalenderContainer = styled.div`
  width: 231px;
  height: 27px;
  display: flex;
  align-items: center;
  margin-left: 8px;
  padding: 0px 15px;
  background: ${colors.white} 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 5px ${colors.filterShadow};
  border-radius: 7px;

  @media(max-width: 500px){
    margin-left: 5px;
    padding: 0px 10px 0px 12px;
    width: auto;
  }
`